import { ReactElement } from "react";
import { ElementProps } from "../../functionalComponents/RenderPage";

const SplitPage = function(): ReactElement<ElementProps> {
  return <></>;
};

export default SplitPage;
